var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_20X20_photo_Back",
    "data-name": "20X20 photo Back",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_221",
    "data-name": "Mask Group 221"
  }, /*#__PURE__*/React.createElement("g", {
    id: "transfer-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19260",
    "data-name": "Path 19260",
    d: "M19.375,12.5a.625.625,0,0,1-.625-.625A4.38,4.38,0,0,0,14.375,7.5H8.333v2.708a.626.626,0,0,1-1.057.452L2.693,6.285a.624.624,0,0,1,0-.9L7.277,1.007a.626.626,0,0,1,1.057.452V4.167h5.208A6.466,6.466,0,0,1,20,10.625v1.25A.625.625,0,0,1,19.375,12.5Z",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19261",
    "data-name": "Path 19261",
    d: "M11.667,18.542V15.833H6.458A6.466,6.466,0,0,1,0,9.375V8.125a.625.625,0,0,1,1.25,0A4.38,4.38,0,0,0,5.625,12.5h6.042V9.792a.625.625,0,0,1,1.057-.452l4.583,4.375a.624.624,0,0,1,0,.9l-4.583,4.375A.626.626,0,0,1,11.667,18.542Z",
    fill: "#404040"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/Transfer.ead5a8801373099e6669de01740a8109.svg";
export { ForwardRef as ReactComponent };